<template>
  <div>
    <v-expansion-panels v-model="panel" multiple hover>
      <v-expansion-panel class="_generalInformation">
        <v-expansion-panel-header
          ><b>General Information</b></v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <v-text-field
            filled
            autocomplete="off"
            label="Email"
            :readonly="readonlyEmail"
            v-model="user.email"
          />
          <v-text-field
            v-if="isNewUser"
            autocomplete="off"
            class="mb-2"
            filled
            hide-details
            label="Password"
            type="text"
            :readonly="readonlyPassword"
            v-model="user.guiPassword"
            @click:append="showPassword = !showPassword"
          />

          <p
            v-if="isNewUser"
            class="
              text-end text-decoration-underline
              secondary--text
              user-select-none
              ma-0
              mb-6
            "
            style="font-size: 0.9rem"
          >
            <b role="button" @click="onGenerateRandomPasswordClicked"
              >Generate random password</b
            >
          </p>

          <v-select
            v-model="user.status"
            filled
            :items="itemsStatus"
            item-value="value"
            item-text="text"
            label="Status"
            :readonly="readonlyStatus"
          ></v-select>

          <v-select
            filled
            :items="roles"
            item-value="roleId"
            item-text="roleName"
            label="Role"
            :disabled="loadingRoles"
            :loading="loadingRoles"
            :readonly="readonlyRole"
            v-model="user.roleId"
            @change="onRoleChanged"
          ></v-select>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel
        v-if="
          user.role != null &&
          user.role.roleName != null &&
          user.role.roleName.trim().toLowerCase() == 'supplier'
        "
        class="_supplierDetails"
      >
        <v-expansion-panel-header
          ><b>Supplier Details</b></v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <v-autocomplete
            v-model="user.supplierInternalId"
            filled
            :items="suppliers"
            item-value="internalId"
            item-text="supplierName"
            label="User's Supplier"
            :disabled="loadingSuppliers"
            :loading="loadingSuppliers"
          ></v-autocomplete>

          <v-layout align-center class="mb-2">
            <p class="ma-0 me-1">Other Suppliers</p>
            <v-tooltip right transition="slide-x-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="secondary"
                  role="button"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-information
                </v-icon>
              </template>
              <span>The suppliers that this user can view</span>
            </v-tooltip>
          </v-layout>
          <v-combobox
            multiple
            solo
            clearable
            chips
            label="Other Suppliers"
            :items="suppliers"
            item-value="internalId"
            item-text="supplierName"
            v-model="user.suppliers"
          >
            <template v-slot:selection="{ attrs, item, select, selected }">
              <v-chip
                v-bind="attrs"
                :input-value="selected"
                close
                color="primary"
                @click="select"
                @click:close="removeSupplier(item)"
                >{{ item.supplierName }}
              </v-chip>
            </template>
          </v-combobox>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import api from "../../../../api";
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    readonlyEmail: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonlyPassword: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonlyStatus: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonlyRole: {
      type: Boolean,
      required: false,
      default: false,
    },
  }, // props
  data() {
    return {
      panel: [0, 1],
      roles: [],
      loadingRoles: false,
      suppliers: [],
      loadingSuppliers: false,
      itemsStatus: [
        { text: "Active", value: "A" },
        { text: "Suspended", value: "S" },
      ],
      showPassword: false,
    };
  }, // data

  computed: {
    isNewUser() {
      return this.user.userId == null || this.user.userId == 0;
    },
    passwordInputType() {
      return this.showPassword ? "text" : "password";
    },
  }, // computed

  mounted() {
    this.loadRolesAsync();
    this.loadSuppliersAsync();
  }, // mounted

  methods: {
    onGenerateRandomPasswordClicked() {
      const password = Math.random().toString(36).slice(-8);
      this.$set(this.user, "guiPassword", password);
    },
    onRoleChanged() {
      this.user.role = this.roles.find(
        (role) => role.roleId == this.user.roleId
      );
    },
    async loadRolesAsync() {
      this.loadingRoles = true;
      this.roles = await api.roles.getAsync();
      this.loadingRoles = false;
    },
    async loadSuppliersAsync() {
      this.loadingSuppliers = true;
      this.suppliers = await api.suppliers.getAll();
      this.loadingSuppliers = false;
    },
    removeSupplier(supplier) {
      const index = this.user.suppliers.findIndex(
        (s) => s.internalId == supplier.internalId
      );
      this.user.suppliers.splice(index, 1);
    },
  }, // methods
};
</script>
